export const initialAuthState = {
  isLoggedIn: false,
  authLoading: true,
  user: null,
  user_role: null,
  menu_access: null,
  userProfile: null,
  deviceInfo: null,
  authError: null,
  ustate: "initial state"
};

export const authReducer = (state, action) => {
  switch (action.type) {
    case "LOGIN":
      return {
        ...state,
        user: action.payload,
        isLoggedIn: true,
        authLoading: false,
      };
    case "MENU_LOADED":
      return {
        ...state,
        menu_access: action.payload,
      };
    case "USER_ROLE_LOADED":
      return {
        ...state,
        user_role: action.payload,
      };
    case "REGISTER":
      return {
        ...state,
        user: action.payload,
        isLoggedIn: true,
        authLoading: false,
      };
    case "LOGOUT":
      return {
        ...state,
        isLoggedIn: false,
        authLoading: false,
        user: null,
        ustate: action.payload
      };
    case "USER_LOADED":
      return {
        ...state,
        isLoggedIn: true,
        authLoading: false,
        user: action.payload
      };
    case "PROFILE_LOADED":
      return {
        ...state,
        userProfile: action.payload
      };
    case "AUTH_ERROR":
      return {
        ...state,
        isLoggedIn: false,
        authLoading: false,
        user: null,
        ustate: action.payload,
        authError: action.payload
      }
    case "DEVICE_INFO_LOADED":
      return {
        ...state,
        deviceInfo: action.payload,
      };
    default:
      return state;
  }
};